import React from 'react';
import SectionGreeting from "./Sections/SectionGreeting";
import SectionHistory from "./Sections/SectionHistory";
import SectionPartners from "./Sections/SectionPartners";
import GraphicSection from "./Sections/GraphicSection";
import SectionLocation from "./Sections/SectionLocation";

function Company() {
  return (
    <div className="Company">
      <GraphicSection/>
      <SectionGreeting/>
      <SectionHistory/>
      <SectionPartners/>
      <SectionLocation/>
    </div>
  );
}

export default Company;
